module.exports = __webpack_public_path__ + "img/blanket.42e15c82.png";